export default 
{
    meta: {
        'title': '取而代之',
        'description': '纯前端Sql日志入参替换工具，将你从逐个参数替换的操作中解放',
        'keywords': 'SQL,MySql,MyBatis,JDBC'
    },
    main: {
        'param': '参数',
        'replace': '替换',
        'tryIt': '试一下',
        'pleaseInput': '请输入',
        'result': '结果',
        'sqlTips': '输入带"?"的 sql 语句, 例(select * from table where a = ? and b = ? and c = ? and d = ?)',
        'paramTips': '输入JDBC日志中带类型的参数，例(a(String),1(Integer),2020-01-01(Timestamp),8.88(BigDecimal))',
        'successMsg': '已复制到粘贴板.',
        'paramsNotMatch': '参数数量不匹配，请检查.',
        'paramsError': '入参格式可能包含全角服务，请检查.'
    }
}